<template>
  <div
    class="px-3"
    :class="$vuetify.breakpoint.smAndDown ? 'pb-3' : undefined"
  >
    <div
      class="quote-expiry"
      :class="!isTimeLeft && 'is-expired'"
    >
      <v-icon
        v-if="isTimeLeft"
        color="text"
        class="mr-1"
      >
        mdi-clock-time-four-outline
      </v-icon>
      <strong v-if="isTimeLeft">
        Quote expires in:
      </strong>
      <a
        href="#"
        class="mx-1 text-decoration-underline"
        :class="expireTimeClass"
        @click.prevent="$emit('open-more-info')"
      >
        {{ timeRemainingText }}
      </a>
      <v-icon
        :small="!isTimeLeft"
        :color="isTimeLeft ? 'text' : 'error'"
        @click="$emit('open-more-info')"
      >
        {{ isTimeLeft ? 'mdi-information-outline' : 'mdi-refresh' }}
      </v-icon>
    </div>
  </div>
</template>

<script>
import useQuoteExpiry from '@/composables/useQuoteExpiry';

export default {
  name: 'results-quote-expiry',
  props: {
    expireTime: {
      type: String,
      required: true,
    },
  },
  setup (props) {
    const {
      isTimeLeft,
      expireTimeClass,
      timeRemainingText,
    } = useQuoteExpiry(props);

    return {
      isTimeLeft,
      expireTimeClass,
      timeRemainingText,
    };
  },
};
</script>

<style scoped lang="scss" src="@/assets/scss/results/quote-expiry.scss" />
